/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AndamentoMeseDto interface.
 */
export function instanceOfAndamentoMeseDto(value) {
    return true;
}
export function AndamentoMeseDtoFromJSON(json) {
    return AndamentoMeseDtoFromJSONTyped(json, false);
}
export function AndamentoMeseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'anno': json['anno'] == null ? undefined : json['anno'],
        'mese': json['mese'] == null ? undefined : json['mese'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}
export function AndamentoMeseDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'anno': value['anno'],
        'mese': value['mese'],
        'count': value['count'],
    };
}
